<app-website-header></app-website-header>

<!-- Hero Banner -->
<section class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
        <!-- <span class="hero-badge"><i class="fas fa-award"></i> Trusted Since Inception</span> -->
        <div class="row align-items-center">
            <div class="col-md-6">

                <h1>Precision-Driven<br><span class="highlight">Machine Solutions</span></h1>
                <p class="hero-subtitle">
                    Tool Room Machineries Sales & Service — empowering industries
                    to perform at their best with quality, reliability, and expert support.
                </p>
                <div class="hero-actions">
                    <a (click)="scrollToProducts()" class="btn-primary-amt" style="cursor:pointer;">
                        <i class="fas fa-tools"></i> Explore Products
                    </a>
                    <!-- <a routerLink="/contact" class="btn-outline-amt">
                <i class="fas fa-headset"></i> Get in Touch
            </a> -->
                </div>

            </div>

            <div class="col-md-6 text-center">
                <img src="assets/img/AMT2.png" alt="Hero Machine" class="hero-machine">
            </div>
        </div>
        <!-- <div class="hero-stats">
            <div class="stat">  
                <span class="stat-number">500+</span>
                <span class="stat-label">Machines Delivered</span>
            </div>
            <div class="stat">
                <span class="stat-number">200+</span>
                <span class="stat-label">Happy Clients</span>
            </div>
            <div class="stat">
                <span class="stat-number">2</span>
                <span class="stat-label">Office Locations</span>
            </div>
        </div> -->
    </div>
    <div class="hero-image-area">
        <div class="hero-machine-badge">
            <i class="fas fa-cog fa-spin"></i>
        </div>
    </div>
</section>

<!-- About Summary -->
<section class="about-summary-section">
    <div class="section-container">
        <div class="about-grid">
            <div class="about-text">
                <span class="section-label"><i class="fas fa-building"></i> Who We Are</span>
                <h2>Welcome to <span class="highlight">Aathreya Machine Tools</span></h2>
                <p>
                    Aathreya Machine Tools (AMT) is a trusted name in the field of Tool Room Machineries
                    Sales & Service. With a strong commitment to quality, reliability, and customer
                    satisfaction, we deliver precision-driven machine solutions that empower industries
                    to perform at their best.
                </p>
                <p>
                    Led by <strong>Mr. M. Manikandan</strong>, Managing Director, AMT has built a reputation
                    for integrity, technical excellence, and prompt service support.
                </p>
                <a routerLink="/about" class="read-more">
                    Learn More About Us <i class="fas fa-arrow-right"></i>
                </a>
            </div>
            <div class="about-features">
                <div class="feature-card" *ngFor="let feature of aboutFeatures">
                    <div class="feature-icon">
                        <i [class]="feature.icon"></i>
                    </div>
                    <div class="feature-info">
                        <h4>{{ feature.title }}</h4>
                        <p>{{ feature.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Category & Products Section -->
<section class="products-section" id="products-section">
    <div class="section-container">
        <div class="section-header">
            <span class="section-label"><i class="fas fa-th-large"></i> Our Products</span>
            <h2>Browse by <span class="highlight">Category</span></h2>
            <p class="section-desc">Explore our wide range of precision machine tools — from milling and lathe machines
                to CNC solutions.</p>
        </div>

        <!-- Category Pills -->
        <div class="category-tabs">
            <button *ngFor="let cat of categories" class="category-pill"
                [class.active]="selectedCategory === cat.categoryId" (click)="selectCategory(cat.categoryId)">
                {{ cat.categoryName }}
            </button>
        </div>

        <!-- Loading -->
        <div class="text-center py-5" *ngIf="isLoading">
            <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
            <p class="text-muted mt-2">Loading products...</p>
        </div>

        <!-- Product Cards -->
        <div class="products-grid" *ngIf="!isLoading && filteredProducts.length > 0">
            <div class="product-card" *ngFor="let product of filteredProducts">
                <a [routerLink]="['/product', product.productId]" class="product-image cursor-pointer d-block">
                    <img [src]="getProductImage(product)" [alt]="product.productName" loading="lazy">
                    <span class="product-badge" *ngIf="product.availability === 'IN_STOCK'">In Stock</span>
                </a>
                <div class="product-info">
                    <h4>{{ product.productName }}</h4>
                    <div class="product-models" *ngIf="product.models && product.models.length > 0">
                        <div class="model-block" *ngFor="let model of product.models; let mi = index">
                            <div class="model-name" *ngIf="product.models.length > 1">
                                <i class="fas fa-cube"></i> {{ model.modelName }}
                            </div>
                            <div class="product-specs"
                                *ngIf="model.specificationValues && model.specificationValues.length > 0">
                                <div class="spec" *ngFor="let sv of model.specificationValues">
                                    <i class="fas fa-bolt"></i>
                                    <div>
                                        <span class="spec-label">{{ sv.specification?.specName || 'Spec' }}</span>
                                        <span class="spec-value">{{ sv.value }} {{ sv.specification?.unit === 'N/A' ? ''
                                            : (sv.specification?.unit || '') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="product-actions mt-3">
                        <a [routerLink]="['/product', product.productId]"
                            class="btn-contact btn-block text-center mr-0">
                            View Details <i class="fas fa-arrow-right ml-1"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="text-center py-5" *ngIf="!isLoading && filteredProducts.length === 0">
            <h4 class="text-muted"><i class="fas fa-info-circle"></i> No products found in this category.</h4>
            <p class="text-muted">Please select another category or check back later.</p>
        </div>

        <div class="section-footer">
            <a routerLink="/products" class="view-all">
                View All Products <i class="fas fa-arrow-right"></i>
            </a>
        </div>
    </div>
</section>

<!-- Why Choose Us -->
<section class="why-section">
    <div class="section-container">
        <div class="section-header">
            <span class="section-label"><i class="fas fa-star"></i> Why Choose Us</span>
            <h2>Your Trusted <span class="highlight">Machinery Partner</span></h2>
        </div>
        <div class="why-grid">
            <div class="why-card" *ngFor="let item of whyChooseUs">
                <div class="why-icon">
                    <i [class]="item.icon"></i>
                </div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
            </div>
        </div>
    </div>
</section>

<!-- Our Locations -->
<section class="locations-section">
    <div class="section-container">
        <div class="section-header">
            <span class="section-label"><i class="fas fa-map-marker-alt"></i> Our Offices</span>
            <h2>Strategically Located to <span class="highlight">Serve You</span></h2>
        </div>
        <div class="locations-grid">
            <div class="location-card">
                <div class="location-icon">
                    <i class="fas fa-city"></i>
                </div>
                <h3>Chennai Office</h3>
                <div class="location-address">
                    <p>Plot No. 8, Dharmalingam Nagar</p>
                    <p>Opp. A.R. Weigh Bridge</p>
                    <p>Thiruneermalai Road</p>
                    <p><strong>Chennai – 600 169</strong></p>
                    <p>Tamil Nadu, India</p>
                </div>
                <a href="tel:+919513266444" class="location-phone">
                    <i class="fas fa-phone-alt"></i> +91 95132 66444
                </a>
            </div>
            <div class="location-card">
                <div class="location-icon">
                    <i class="fas fa-industry"></i>
                </div>
                <h3>Hosur Office</h3>
                <div class="location-address">
                    <p>No. 5/10, Plot No. 11</p>
                    <p>Bedarapallai Road</p>
                    <p>Santhapuram Agraharam</p>
                    <p><strong>Hosur – 635 136</strong></p>
                    <p>Tamil Nadu, India</p>
                </div>
                <a href="tel:+919036022687" class="location-phone">
                    <i class="fas fa-phone-alt"></i> +91 90360 22687
                </a>
            </div>
        </div>
    </div>
</section>

<!-- CTA Banner -->
<section class="cta-section">
    <div class="section-container">
        <div class="cta-content">
            <h2>Ready to Upgrade Your Machine Tools?</h2>
            <p>Contact us today for the best machinery solutions and service support.</p>
            <div class="cta-actions">
                <a routerLink="/contact" class="btn-primary-amt">
                    <i class="fas fa-paper-plane"></i> Request a Quote
                </a>
                <a href="tel:+919513266444" class="btn-outline-light">
                    <i class="fas fa-phone-alt"></i> Call Us Now
                </a>
            </div>
        </div>
    </div>
</section>

<!-- Enquiry Modal -->
<div class="enquiry-modal-backdrop" *ngIf="isEnquiryModalOpen">
    <div class="enquiry-modal">
        <div class="enquiry-modal-header">
            <div>
                <h5 class="m-0"><i class="fas fa-paper-plane mr-2"></i>Contact Dealer</h5>
                <small class="text-light">Enquiry for: {{ enquiryProductName }}</small>
            </div>
            <button class="close-btn" (click)="closeEnquiryModal()">&times;</button>
        </div>
        <div class="enquiry-modal-body">
            <div class="row">
                <div class="col-md-6 form-group">
                    <label>Customer Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.customerName"
                        placeholder="Your full name">
                </div>
                <div class="col-md-6 form-group">
                    <label>Phone Number <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.phoneNumber"
                        placeholder="Your phone number">
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 form-group">
                    <label>Door No</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.doorNo"
                        placeholder="Door / Plot number">
                </div>
                <div class="col-md-4 form-group">
                    <label>Street</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.street" placeholder="Street name">
                </div>
                <div class="col-md-4 form-group">
                    <label>Village</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.village"
                        placeholder="Village / Area">
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 form-group">
                    <label>City</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.city" placeholder="City">
                </div>
                <div class="col-md-4 form-group">
                    <label>State</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.state" placeholder="State">
                </div>
                <div class="col-md-4 form-group">
                    <label>Pincode</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.pincode" placeholder="Pincode">
                </div>
            </div>
            <div class="form-group">
                <label>Message</label>
                <textarea class="form-control" [(ngModel)]="enquiryForm.message" rows="3"
                    placeholder="Your message or specific requirements..."></textarea>
            </div>
            <div class="text-right mt-3">
                <button type="button" class="btn btn-secondary mr-2" (click)="closeEnquiryModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitEnquiry()" [disabled]="isSubmitting">
                    <i class="fas fa-paper-plane mr-1" *ngIf="!isSubmitting"></i>
                    <i class="fas fa-spinner fa-spin mr-1" *ngIf="isSubmitting"></i>
                    {{ isSubmitting ? 'Sending...' : 'Send Enquiry' }}
                </button>
            </div>
        </div>
    </div>
</div>

<app-website-footer></app-website-footer>